// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Selectable from 'components/focus/Selectable';
import styles from './SettingsTile.module.scss';

const SettingsTile = ({ id, onClick, tts, children, className }) => (
  <Selectable
    focusId={`setting-item-${id}`}
    className={className}
    ttsText={tts}
    onSelect={onClick}
    render={({ hasFocus }) => (
      <div
        data-testid="settings-tile"
        className={classNames(
          styles.tile,
          hasFocus ? styles.focused : styles.unfocused,
        )}
      >
        <button
          type="button"
          onClick={onClick}
          className={classNames('w-100 h-100', styles.button)}
        >
          <div className={classNames('w-100 h-100', styles.imageOverlay)} />
          <div
            className={classNames(
              'w-100 h-100',
              'd-flex flex-column align-items-center justify-content-center',
              styles.content,
            )}
          >
            {children}
          </div>
        </button>
      </div>
    )}
  />
);

SettingsTile.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  tts: PropTypes.string,
  children: PropTypes.node.isRequired,
};

SettingsTile.defaultProps = {
  onClick: () => {},
  tts: '',
  className: null,
};

export default React.memo(SettingsTile);
